/* eslint-disable */
import ReactDOM from 'react-dom';
import React from 'react';
import Root from './Root';
import { unregister } from './registerServiceWorker'; // <===ilian added this

// ===>ilian disabled this import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<Root />, document.getElementById('root'));
// ===>ilian disabled this registerServiceWorker();

unregister(); // <===ilian added this



// WEBPACK FOOTER //
// ./src/index.js